var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("JobsOccupationsResume", {
        attrs: {
          jobs: _vm.value.perimeter_jobs,
          occupations: _vm.value.perimeter_occupations,
          displayWishes: false,
          jobColors: _vm.jobColors,
          occupationColors: _vm.occupationColors,
        },
      }),
      _vm._v(" "),
      _vm.resource.skills.length
        ? _c(
            "vs-row",
            { staticClass: "checkboxes-container mt-10" },
            [
              _c(
                "vs-col",
                {
                  attrs: {
                    "vs-type": "flex",
                    "vs-justify": "flex-start",
                    "vs-align": "center",
                    "vs-w": "4",
                  },
                },
                [
                  _vm.typeForm !== "creation" && _vm.typeForm !== "poursuite"
                    ? [
                        _c("label", { staticClass: "ml-20" }, [
                          _vm._v("Affichage :"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "vs-radio",
                          {
                            staticClass: "ml-2",
                            attrs: {
                              "vs-name": "radios-occSkill-display",
                              id: "radio-occSkill-display-table",
                              "vs-value": "table",
                            },
                            model: {
                              value: _vm.displayMode,
                              callback: function ($$v) {
                                _vm.displayMode = $$v
                              },
                              expression: "displayMode",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Tableau\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "vs-radio",
                          {
                            staticClass: "ml-2",
                            attrs: {
                              "vs-name": "radios-occSkill-display",
                              id: "radio-occSkill-display-graphic",
                              "vs-value": "graphic",
                            },
                            model: {
                              value: _vm.displayMode,
                              callback: function ($$v) {
                                _vm.displayMode = $$v
                              },
                              expression: "displayMode",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Graphique\n                    "
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "vs-col",
                { attrs: { "vs-w": "8" } },
                [
                  _c(
                    "vs-row",
                    { staticClass: "mt-2" },
                    [
                      !_vm.isValidationOrConsultation
                        ? _c(
                            "vs-col",
                            { staticClass: "mt-2", attrs: { "vs-w": "3" } },
                            [
                              _c(
                                "vs-checkbox",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: {
                                        content:
                                          "Pré-remplissage automatique des compétences lié à l'évaluation des savoir-faire appelant ces compétences",
                                        placement: "top-start",
                                      },
                                      expression:
                                        "{\n                                content: 'Pré-remplissage automatique des compétences lié à l\\'évaluation des savoir-faire appelant ces compétences',\n                                placement: 'top-start',\n                            }",
                                    },
                                  ],
                                  attrs: {
                                    name: "checkboxSuggestionFromOccupationSkills",
                                    disabled: !_vm.hasOccupationSkills,
                                  },
                                  model: {
                                    value: _vm.suggestionFromOccupationSkills,
                                    callback: function ($$v) {
                                      _vm.suggestionFromOccupationSkills = $$v
                                    },
                                    expression:
                                      "suggestionFromOccupationSkills",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            Suggestion de pré-remplissage\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "vs-col",
                        { attrs: { "vs-w": "4" } },
                        [
                          _vm.hasPersonals
                            ? _c(
                                "vs-checkbox",
                                {
                                  attrs: {
                                    name: "checkboxComparePortalPersonal",
                                  },
                                  model: {
                                    value: _vm.comparePortalPersonal,
                                    callback: function ($$v) {
                                      _vm.comparePortalPersonal = $$v
                                    },
                                    expression: "comparePortalPersonal",
                                  },
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "other_level vs-component con-vs-radio vs-radio-primary",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "other_level_type_0" },
                                        [_vm._v("|")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                            Auto-évaluation Portail " +
                                      _vm._s(
                                        _vm.hasPersonals
                                          ? `du ${this.formatDate(
                                              _vm.resource.personals[0]
                                                .rating_date
                                            )}`
                                          : ""
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "vs-col",
                        { attrs: { "vs-w": "5" } },
                        [
                          _vm.hasExternals
                            ? _c(
                                "vs-checkbox",
                                {
                                  attrs: {
                                    name: "checkboxComparePortalExternal",
                                  },
                                  model: {
                                    value: _vm.comparePortalExternal,
                                    callback: function ($$v) {
                                      _vm.comparePortalExternal = $$v
                                    },
                                    expression: "comparePortalExternal",
                                  },
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "other_level vs-component con-vs-radio vs-radio-primary",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "other_level_type_1" },
                                        [_vm._v("|")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.resource.externals[0].eval_type
                                      ) +
                                      " " +
                                      _vm._s(
                                        `du ${this.formatDate(
                                          _vm.resource.externals[0].rating_date
                                        )}`
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasTwoExternals
                            ? _c(
                                "vs-checkbox",
                                {
                                  attrs: {
                                    name: "checkboxComparePortalSecondExternal",
                                  },
                                  model: {
                                    value: _vm.comparePortalSecondExternal,
                                    callback: function ($$v) {
                                      _vm.comparePortalSecondExternal = $$v
                                    },
                                    expression: "comparePortalSecondExternal",
                                  },
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "other_level vs-component con-vs-radio vs-radio-primary",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "other_level_type_2" },
                                        [_vm._v("|")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.resource.externals[1].eval_type
                                      ) +
                                      " " +
                                      _vm._s(
                                        `du ${this.formatDate(
                                          _vm.resource.externals[1].rating_date
                                        )}`
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : !_vm.loading
        ? _c("div", { staticClass: "not-data-table vs-table--not-data" }, [
            _vm._v("Il n'y a aucune compétence à évaluer"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.displayMode === "table" && (_vm.resource.skills.length || _vm.loading)
        ? _c("Rating-Manager", {
            attrs: {
              name: "skills",
              "type-form": _vm.typeForm,
              "show-hidden": _vm.resource.allSkills,
              col1: {
                label: "Compétence",
                value: "title",
                title: "description",
                chip: true,
                chipColor: "color",
              },
              col2: { label: "Catégorie", value: "category_name" },
              loading: _vm.loading,
              "skill-review": _vm.skillReview,
            },
            model: {
              value: _vm.resource.skills,
              callback: function ($$v) {
                _vm.$set(_vm.resource, "skills", $$v)
              },
              expression: "resource.skills",
            },
          })
        : _vm.displayMode === "graphic"
        ? _c(
            "div",
            { staticClass: "chart main" },
            [
              _c("Rating-Chart", {
                staticClass: "main-chart",
                attrs: {
                  employee: _vm.value.employee,
                  options: _vm.chart.options,
                  "chart-data": _vm.chart.data,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }